import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideOAuthClient } from 'angular-oauth2-oidc';

import { AppConfigService } from '../config-loader/app-config.service';
import { ApiUrlService } from '../services/api-url.service';

export function provideSharedDataAccess(): EnvironmentProviders[] {
  return [
    provideOAuthClient({
      resourceServer: {
        sendAccessToken: true,
      },
    }),
    makeEnvironmentProviders([AppConfigService, ApiUrlService]),
  ];
}
